import { render, staticRenderFns } from "./FaceHandsLab.vue?vue&type=template&id=6d85881b&scoped=true"
import script from "./FaceHandsLab.vue?vue&type=script&lang=js"
export * from "./FaceHandsLab.vue?vue&type=script&lang=js"
import style0 from "./FaceHandsLab.vue?vue&type=style&index=0&id=6d85881b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d85881b",
  null
  
)

export default component.exports